import { render, staticRenderFns } from "./dish-table.vue?vue&type=template&id=6341c440&scoped=true"
import script from "./dish-table.vue?vue&type=script&lang=js"
export * from "./dish-table.vue?vue&type=script&lang=js"
import style0 from "./dish-table.vue?vue&type=style&index=0&id=6341c440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6341c440",
  null
  
)

export default component.exports